<template>
    <v-container fluid>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0 mt-5">
            <v-toolbar-title class="white--text"> Zone Competenza </v-toolbar-title>
            <v-spacer />
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="addZona" v-bind="attrs" v-on="on" small>
                        <v-icon color="primary">mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Agg. Zona</span>
            </v-tooltip>
            <v-spacer />
        </v-toolbar>
        <v-container>
            <v-treeview dense transition rounded id="id_zona_master" :items="items_zone">
                <template v-slot:prepend="{ item }">
                    <v-icon v-if="item.id_zona_master" class="ml-6" @click="editItem(item)" color="primary">
                        mdi-pencil
                    </v-icon>
                </template>
                <template v-slot:label="{ item }">
                    <span>
                        {{
                            item.descrizione
                        }}
                    </span>
                </template>
                <template v-slot:append="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="item.id_zona_master" icon v-bind="attrs" v-on="on" @click="deleteZona(item)"
                                color="error">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Elimina</span>
                    </v-tooltip>
                </template>
            </v-treeview>
        </v-container>


        <v-dialog v-model="dialog_add_zona" width="70%">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text">{{
                        zona_sel.id_zona_master != null ?
                            'Modifica Zona' : 'Crea Zona'
                    }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="confermaSaveZona" v-on="on" small>
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="chiudiDialogZona" small>
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-container>
                    <v-row justify="center" class="ml-8 mr-8 ma-2">
                        <v-col cols="6">
                            <v-text-field v-model="zona_sel.descrizione" label="Nome zona" dense hide-details />
                        </v-col>
                        <v-col cols="6">
                            <v-select dense hide-details label="Seleziona stato" item-text="stato" item-value="id_stato"
                                v-model="zona_sel.id_stato" :items="items_nazioni" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-treeview dense rounded :items="items_regioni" item-key="id" activatable>
                            <template v-slot:prepend="{ item }">
                                <v-checkbox dense hide-details :input-value="item.selected"
                                    @change="() => handleCheckboxClick(item)" />
                            </template>
                        </v-treeview>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>


        <v-dialog v-model="dialog_conferma_save_zona" width="50%">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text">Conferma Salvataggio
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="saveZona" v-on="on" small>
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="dialog_conferma_save_zona = false" small>
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-container>
                    <v-row justify="center" class="mt-2">
                        <v-col>
                            Confermi il salvataggio dei seguenti elementi?
                        </v-col>
                    </v-row>
                    <v-row class="ma-4">
                        <v-treeview dense rounded :items="items_zone_selezionate" item-key="id" activatable>
                        </v-treeview>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>


        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />

        <!-- Overlay di caricamento -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" />
        </v-overlay>
        <v-overlay :value="overlay2">
            <v-progress-circular indeterminate size="64" />
        </v-overlay>
    </v-container>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Zona {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutti i campi
    reset() {
        const campi = this.setCampi();
        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "id_zona_master", default_val: null },
            { nome: "id_stato", default_val: 100 },
            { nome: "ordinamento", default_val: 1 },
            { nome: "descrizione", default_val: "" },
            { nome: "zona_dettagli", default_val: [] },
            { nome: "validita", default_val: 1 }
        ];

        return campi;
    }
}

class Comune {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutti i campi
    reset() {
        const campi = this.setCampi();
        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "id_zona_dettaglio", default_val: null },
            { nome: "id_zona_master", default_val: null },
            { nome: "id_stato", default_val: null },
            { nome: "id_regione", default_val: null },
            { nome: "id_provincia", default_val: null },
            { nome: "id_comune", default_val: null },
            { nome: "validita", default_val: 1 }
        ];

        return campi;
    }
}
export default {
    name: "QLZoneCompetenza",
    components: { SnackbarQV },
    data() {
        return {
            // Variabili d'appoggio
            zona_sel: new Zona(),
            comune_sel: new Comune(),
            id_regione: null,
            id_provincia: null,

            // Modal
            dialog_add_zona: false,
            dialog_conferma_save_zona: false,
            overlay: false,
            overlay2: false,

            //   Array
            items_zone: [],
            items_comuni: [],
            items_detteglio: [],
            items_regioni: [],
            items_regioni_ori: [],
            items_province: [],
            items_nazioni: [],
            items_zone_selezionate: [],
            headers: [
                {
                    text: "Modifica",
                    value: "modifica",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Descrizione",
                    value: "descrizione",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Elimina",
                    value: "elimina",
                    filterable: false,
                    sortable: false,
                },
            ],
        };
    },
    methods: {
        handleCheckboxClick(item) {
            console.log("item", item);

            item.selected = !item.selected;

            // Se REGIONE e ha figli, carica province se non ci sono
            if (item.regione !== undefined && !item.id_provincia && item.children?.length === 0) {
                this.getProvince(item.id_regione);
            }

            // Se PROVINCIA e ha figli, carica comuni se non ci sono
            if (item.id_provincia != undefined && item.children == undefined && item.id_comune == null) {
                console.log("entra getcomuni");

                this.getComuni(item.id_provincia);
            }

            // === Se ha figli (REGIONE o PROVINCIA) ===
            if (item.children && item.children.length > 0) {
                // Seleziona o deseleziona tutti i figli
                item.children.forEach(child => {
                    child.selected = item.selected;

                    // Deseleziona anche i figli dei figli (comuni), se presenti
                    if (child.children && child.children.length > 0) {
                        child.children.forEach(grandChild => {
                            grandChild.selected = item.selected;
                        });
                    }
                });
            }

            // === Se è un COMUNE ===
            if (item.id_comune) {
                this.updateParentSelectionFromComune(item);
            }

            // === Se è una PROVINCIA ===
            if (item.id_provincia && !item.id_comune) {
                this.updateParentSelectionFromProvincia(item);
            }
        },
        updateParentSelectionFromComune(comune) {
            for (const regione of this.items_regioni) {
                for (const provincia of regione.children || []) {
                    const matchComune = (provincia.children || []).find(c => c.id_comune === comune.id_comune);
                    if (matchComune) {
                        // Provincia è selezionata se almeno un comune lo è
                        provincia.selected = provincia.children.some(c => c.selected);

                        // Regione è selezionata se almeno una provincia è selezionata
                        regione.selected = regione.children.some(p => p.selected);
                        return;
                    }
                }
            }
        },
        updateParentSelectionFromProvincia(provincia) {
            for (const regione of this.items_regioni) {
                const matchProvincia = (regione.children || []).find(p => p.id_provincia === provincia.id_provincia);
                if (matchProvincia) {
                    // Regione è selezionata se almeno una provincia lo è
                    regione.selected = regione.children.some(p => p.selected);
                    return;
                }
            }
        },
        // handleCheckboxClick(item) {
        //     console.log("item", item);

        //     item.selected = !item.selected;

        //     if (!item.id_comune) {

        //         if (item.regione != undefined && item.children.length == 0) {
        //             this.getProvince(item.id_regione);
        //         } else if (item.id_provincia != undefined && item.children.length == 0) {
        //             console.log("ma scusa entra qua dentro?");

        //             this.getComuni(item.id_provincia);
        //         }
        //     }

        //     if (item.id_comune == null && item.children.length != 0) {
        //         console.log("entra cambio stato figli");

        //         item.children.forEach(e => {
        //             e.selected = item.selected == true ? true : false;
        //             console.log("eeee", e.selected);

        //         })
        //     }
        // },
        addZona() {
            this.dialog_add_zona = true;
            this.comune_sel = new Comune();
            this.zona_sel = new Zona();
        },
        chiudiDialogZona() {
            this.dialog_add_zona = false;
            this.zona_sel = new Zona();
            this.comune_sel = new Comune();
            this.items_regioni = JSON.parse(JSON.stringify(this.items_regioni_ori));
            // this.clearCheckboxes(this.items_regioni);
        },
        clearCheckboxes(items) {
            if (!items || !Array.isArray(items)) return;

            items.forEach(item => {
                this.$set(item, 'selected', false); // reset checkbox

                if (item.children && item.children.length > 0) {
                    this.clearCheckboxes(item.children); // ricorsione su figli
                }
            });
        },
        async editItem(zona) {
            this.overlay2 = true;
            this.zona_sel = zona;

            const dettagli = zona.zona_dettagli;
            const comuni_selezionati = dettagli.map(d => d.id_comune);
            const regioniUniche = [...new Set(dettagli.map(d => d.id_regione))];

            // 1. Carica le province per tutte le regioni necessarie
            for (const id_regione of regioniUniche) {
                await this.getProvince(id_regione); // Assicura che items_regioni venga popolato
            }

            // 2. Per ogni regione caricata
            for (let regione of this.items_regioni) {
                // Trova se la regione è tra quelle selezionate
                if (!regioniUniche.includes(regione.id_regione)) continue;

                // 3. Per ogni provincia nella regione
                for (let i = 0; i < regione.children.length; i++) {
                    const provincia = regione.children[i];

                    // 4. Carica i comuni della provincia e assegnali
                    const comuni = await this.getComuni(provincia.id_provincia);
                    console.log("comuni dentro edit", comuni);


                    if (Array.isArray(comuni) && comuni.length > 0) {
                        comuni.forEach(comune => {
                            comune.selected = comuni_selezionati.includes(comune.id_comune);
                            comune.name = comune.comune;
                            comune.id = comune.id_comune;
                        });

                        // Assegna i comuni alla provincia (assicurando reattività)
                        this.$set(regione.children[i], "children", comuni);
                    }
                }
            }

            // 3. Seleziona automaticamente province e regioni in base ai comuni
            function aggiornaSelezioneGenitori(nodi) {
                nodi.forEach(nodo => {
                    if (nodo.children && nodo.children.length > 0) {
                        aggiornaSelezioneGenitori(nodo.children);
                        nodo.selected = nodo.children.some(child => child.selected);
                    }
                });
            }

            aggiornaSelezioneGenitori(this.items_regioni);

            // 5. Apri il dialog e disattiva overlay
            this.dialog_add_zona = true;
            this.overlay2 = false;
        },
        deleteZona(arg) {
            this.zona_sel = new Zona(arg);
            this.zona_sel.validita = 0;
            console.log("elimina zona", arg, this.zona_sel);
            this.saveZona();
        },
        getZone() {
            this.overlay2 = true;
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getzone",
                    id_regione: null,
                    id_provincia: null,
                    id_comune: null
                },
            };
            this.$store.dispatch("api", getconfig).then((res) => {
                this.overlay2 = false;
                 this.items_zone = [];
                if (res.status === 200) {
                    this.items_zone = res.data.result != null ? res.data.result : [];

                    this.items_zone.forEach(z => {
                        let regioni = [];

                        if (z.zona_dettagli && z.zona_dettagli.length > 0) {
                            z.zona_dettagli.forEach(d => {
                                // Cerca o aggiungi la regione
                                let regione = regioni.find(r => r.id_regione === d.id_regione);
                                if (!regione) {
                                    regione = {
                                        id_regione: d.id_regione,
                                        id: d.id_regione,
                                        descrizione: d.regione,
                                        selected: false,
                                        children: []
                                    };
                                    regioni.push(regione);
                                }

                                // Cerca o aggiungi la provincia dentro la regione
                                let provincia = regione.children.find(p => p.id_provincia === d.id_provincia);
                                if (!provincia) {
                                    provincia = {
                                        id_provincia: d.id_provincia,
                                        id: d.id_provincia,
                                        descrizione: d.provincia,
                                        selected: false,
                                        children: []
                                    };
                                    regione.children.push(provincia);
                                }

                                // Aggiungi il comune alla provincia
                                const comune = {
                                    id_comune: d.id_comune,
                                    id: d.id_comune,
                                    descrizione: d.comune,
                                    selected: true
                                };

                                provincia.children.push(comune);
                            });
                        }

                        // Assegna la struttura a una proprietà (es. per treeview)
                        z.children = regioni;
                        z.id_stato = z.zona_dettagli.length != 0 ? z.zona_dettagli[0].id_stato : 100;


                    });
                    console.log("items_zone", this.items_zone);
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            }).catch((err) => {
                this.overlay = false;
                this.$refs.SnackbarQV.print("error", err.toString());
            });
        },
        buildZonaDettagliFromTree() {
            const zona_dettagli = [];

            this.items_regioni.forEach(regione => {
                if (regione.selected) {
                    const id_regione = regione.id_regione;

                    (regione.children || []).forEach(provincia => {
                        const id_provincia = provincia.id_provincia;

                        (provincia.children || []).forEach(comune => {
                            if (comune.selected) {
                                zona_dettagli.push({
                                    id_stato: this.zona_sel.id_stato,
                                    id_regione: id_regione,
                                    id_provincia: id_provincia,
                                    id_comune: comune.id_comune,
                                });
                            }
                        });
                    });
                }

            });

            return zona_dettagli;
        },
        confermaSaveZona() {
            console.log("this.items_regioni", this.items_regioni);
            
            this.items_zone_selezionate = this.items_regioni
                .filter(e => e.selected)
                .map(r => ({
                    ...r,
                    children: r.children
                        .filter(p => p.selected)
                        .map(p => ({
                            ...p,
                            children: p.children.filter(c => c.selected)
                        }))
                }));

            this.dialog_conferma_save_zona = true;
        },
        saveZona() {
            this.overlay = true;
            let arr = this.buildZonaDettagliFromTree();
            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "savezona",
                    token: localStorage.getItem("user_token"),
                    id_zona_master: this.zona_sel.id_zona_master,
                    id_stato: this.zona_sel.id_stato,
                    ordinamento: this.zona_sel.ordinamento,
                    descrizione: this.zona_sel.descrizione,
                    zona_dettagli: arr,
                    validita: this.zona_sel.validita,
                },
            };


            this.$store.dispatch("api", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        this.dialog_add_zona = false;
                        this.dialog_conferma_save_zona = false;
                        this.zona_sel = new Zona();
                        this.getZone();
                        this.items_regioni = JSON.parse(JSON.stringify(this.items_regioni_ori));
                    } else {
                        this.$refs.SnackbarQV.print("orange", "Errore di comunicazione col server, non è stato possibile caricare i dati.");
                    }
                })
                .catch((e) => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
                });
        },
        message(message) {
            this.$refs.SnackbarQV.print("orange", message);
        },

        getNazioni() {
            const getregioni = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getnazioni",
                },
            };

            this.overlay = true;
            this.$store.dispatch("api", getregioni).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.items_nazioni = res.data.result ? res.data.result : [];
                } else this.$refs.SnackbarQV.print("orange", "Errore di comunicazione col server, non è stato possibile caricare i dati.");
            }).catch((e) => {
                this.overlay = false;
                this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
            });
        },
        getRegioni() {
            // Chiamata per prendere le regioni.
            const getregioni = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getregioni",
                },
            };

            this.overlay = true;
            this.$store.dispatch("api", getregioni).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.items_regioni = res.data.result ? res.data.result : [];

                    this.items_regioni.forEach(e => {
                        e.name = e.regione;
                        e.id = e.id_regione;
                        e.selected = false;
                        e.children = [];
                    })

                    this.items_regioni_ori = JSON.parse(JSON.stringify(this.items_regioni));
                } else this.$refs.SnackbarQV.print("orange", "Errore di comunicazione col server, non è stato possibile caricare i dati.");
            })
                .catch((e) => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
                });
        },

        async getProvince(id_regione) {
            // Chiamata per prendere le province legate alla regione.
            if (!id_regione) return;

            let getprovince = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getprovince",
                    id_regione: id_regione
                },
            };

            this.overlay = true;

            await this.$store.dispatch("api", getprovince).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    res.data.result.forEach(e => {
                        e.name = e.provincia;
                        e.id = e.id_provincia;
                        e.selected = false;
                    })
                    const index = this.items_regioni.findIndex(r => r.id_regione == id_regione);
                    if (index !== -1) {
                        const updated = {
                            ...this.items_regioni[index],
                            children: res.data.result
                        };

                        this.$set(this.items_regioni, index, updated);
                    }
                }
            })
                .catch((e) => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
                });
        },

        // async getComuni(id_provincia) {
        //     this.overlay = true;

        //     const getcomuni = {
        //         controller: "logistic",
        //         method: "POST",
        //         richiesta: {
        //             token: localStorage.getItem("user_token"),
        //             action: "getcomuni",
        //             id_provincia: id_provincia
        //         },
        //     };
        //     await this.$store.dispatch("api", getcomuni).then((res) => {
        //         this.overlay = false;
        //         if (res.status == 200) {
        //             res.data.result.forEach(e => {
        //                 e.name = e.comune;
        //                 e.id = moment().valueOf() + Math.random() * 100;
        //             });

        //             // Cerca la provincia dentro ogni regione
        //             this.items_regioni.forEach((regione, regioneIndex) => {
        //                 if (regione.children.length != 0) {
        //                     regione.children.forEach((provincia, provinciaIndex) => {
        //                         if (provincia.id_provincia === id_provincia) {
        //                             const updatedProvincia = {
        //                                 ...provincia,
        //                                 children: res.data.result
        //                             };
        //                             this.$set(this.items_regioni[regioneIndex].children, provinciaIndex, updatedProvincia);
        //                         }
        //                     });
        //                 }
        //             });

        //             return res.data.result;
        //         } else {
        //             this.$refs.SnackbarQV.print("orange", "Errore di comunicazione col server, non è stato possibile caricare i dati.");
        //         }
        //     }).catch((e) => {
        //         this.overlay = false;
        //         this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
        //     });
        // }
        async getComuni(id_provincia) {
            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getcomuni",
                    id_provincia
                }
            };

            const res = await this.$store.dispatch("api", request);
            if (res.status === 200 && res.data.result) {
                res.data.result.forEach(e => {
                    e.name = e.comune;
                    e.id = e.id_comune;
                    e.selected = true;
                });
                this.items_regioni.forEach((regione, regioneIndex) => {
                    if (regione.children.length != 0) {
                        regione.children.forEach((provincia, provinciaIndex) => {
                            if (provincia.id_provincia === id_provincia) {
                                const updatedProvincia = {
                                    ...provincia,
                                    children: res.data.result
                                };
                                this.$set(this.items_regioni[regioneIndex].children, provinciaIndex, updatedProvincia);
                            }
                        });
                    }
                });
                return res.data.result.map(c => ({
                    ...c,
                }));
            }
            return [];
        }
    },

    created() { },
    mounted() {
        this.getZone();
        this.getRegioni();
        this.getNazioni();
    },
};
</script>
<style>
.v-treeview-node__label {
    text-align: left;
}
</style>